import { defineStore } from 'pinia'
import type { PackageItem } from '#lib/types'
import { AppStoreEnum } from '#lib/enums'
import { persistedState } from '#imports'

interface Packages {
  packages: PackageItem[]
}

export const usePackageStore = defineStore(AppStoreEnum.Packages, {
  state: (): Packages => ({
    packages: [],
  }),
  persist: {
    storage: persistedState.localStorage,
  },
  actions: {
    setPackages(data: PackageItem[]) {
      this.packages = data
    },
    resetPackages() {
      this.packages = []
    },
  },
})
